import { type SystemNotification, allSystemNotificationsFn } from "../common/openapi";

import type { UseFullQueryOptions } from "./react-query";

export const querySystemNotifications = {
	queryKey: ["systemNotifications"],
	queryFn: async () => {
		const { notifications } = await allSystemNotificationsFn({});

		return notifications;
	},
} satisfies UseFullQueryOptions<ReadonlyArray<SystemNotification>, Error>;
